// extracted by mini-css-extract-plugin
export default {"root":"DraggableVContainers_root__Elmlj"};